import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CustomerConst } from '@app/constants/customer-const';
import { Customer } from '@app/models/customer';
import { CustomerSummary } from '@app/models/customer-summary';


@Component({
    selector: 'app-customer-advanced-search-form-result',
    templateUrl: './advanced-search-form-result.component.html',
    styleUrls: ['./advanced-search-form-result.component.css'],
    standalone: false
})
export class AdvancedSearchFromResultComponent implements OnChanges {

  selectedCustomer: CustomerSummary;

  @Input() customers: Array<CustomerSummary>;
  @Input() totalCustomers: number;
  @Input() pageSizeCustomers: number;
  @Input() displaySearchDialog: boolean;
  @Output() onSubmit = new EventEmitter<Customer>();
  @Output() onCancel = new EventEmitter();
  @Output() onLoadData = new EventEmitter<any>();

  constructor() { }


  ngOnChanges()
  {
    if(!this.customers){
      this.customers = new Array<CustomerSummary>();
    }
  }

  getPassportNumber(customer: CustomerSummary) {
    const document = customer.document;
    if (document && (document.type === CustomerConst.IDENTITY_TYPE.NATIONAL_PASSPORT || document.type === CustomerConst.IDENTITY_TYPE.FOREIGN_PASSPORT)) {
      return document.serialNumber;
    }
    return "";
  }

  cancelSearch() {
    this.onCancel.emit();
  }


  onSelect() {
    if(this.selectedCustomer)
    {
      // Downstream consumers expect a Customer-shaped object with companyName;
      // the summary endpoint only returns a generic display "name".
      const customerToEmit = {
        ...this.selectedCustomer,
        companyName: this.selectedCustomer.name
      } as unknown as Customer;
      this.onSubmit.emit(customerToEmit);
    }
  }

  pageChangeEvent(event){
    this.onLoadData.emit(event);
  }

  selectCustumner(customer){
    this.selectedCustomer = customer;
  }
}
